import { render, staticRenderFns } from "./DictRadio.vue?vue&type=template&id=cf18d22e&scoped=true"
import script from "./DictRadio.vue?vue&type=script&lang=js"
export * from "./DictRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf18d22e",
  null
  
)

export default component.exports